import * as Yup from "yup";

export const co2ReportsFilterFormInitialValues = {
  objectType: [],
  group: [],
  object: [],
  key: [],
  daysOfWeek: ["0", "1", "2", "3", "4", "5", "6"],
  startTime: null,
  endTime: null,
  assignedToAllObjects: true,
  showInactiveObjects: false
  // rideMode: [], // TODO will be added later
  // excludeRides: false, // TODO will be added later
};
